import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { LMNClaim, LMNClaimDto } from '@/modules/MyDocuments/myDocuments.types';

interface Response {
  id?: number;
  claims?: LMNClaimDto[];
}

interface FormattedResponse {
  id?: string;
  claims?: LMNClaim[];
}

export interface CreateLMNPayload {
  name?: string;
  description?: string;
  documentId?: string;
  employeeId?: string;
  claimIds?: string[];
}

const useCreateLettersOfMedicalNecessityQuery = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    // TODO: fix types type should be ILetterOfMedicalNecessityDto
    (payload: CreateLMNPayload) =>
      api.post<Response>(API_URL.LETTERS_OF_MEDICAL_NECESSITY, {
        name: payload?.name,
        description: payload?.description,
        document_id: payload.documentId,
        employee_id: payload?.employeeId,
        claim_ids: payload?.claimIds?.length ? payload?.claimIds : [],
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [API_URL.LETTERS_OF_MEDICAL_NECESSITY],
        });
      },
    }
  );

  const createLMN = useCallback(
    async (payload: CreateLMNPayload): Promise<FormattedResponse> => {
      const response = await mutateAsync(payload);
      return {
        id: toString(response?.data?.id),
        claims:
          response?.data?.claims?.map((claim) => ({
            claimId: toString(claim?.claim_id),
            providerName: claim?.provider_name,
            serviceId: toString(claim?.service_id),
            statusType: claim?.status_type,
            approvalStatus: claim?.approval_status,
            requestedAmount: claim?.requested_amount,
            serviceOn: claim?.service_on,
          })) || [],
      };
    },
    [mutateAsync]
  );

  return {
    createLMN,
    isLoading,
  };
};

export default useCreateLettersOfMedicalNecessityQuery;
